var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.colorNumbers},[_c('span',{class:_vm.classObject},[_vm._v(" "+_vm._s(_vm.getTempoStatus(_vm.machine.inicioStatus))+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }